import React, { useState } from 'react';
import '../../Common/Custom.css';
import { useParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import ScanVerification from '../../Common/ScanVerification';
import QueryForm from '../../Common/QueryForm';
import PageTabs from '../../Common/PageTabs';

 
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow:'none',
}));






function Serial(props) {

 const { qrCode } = useParams([]);

  const [scanResult, setScanResult] = useState(null);

  const handleScanResult = (data, kind) => {
    setScanResult(data);
    if (data === null && kind === 'notfound') {
      window.setTimeout(function () {
        window.location.href = '/not-found';
      }, 1);
      return;
    }
    if (data && data.alreadyScanned) {
      handleClickOpen();
    }
  };

  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  
  const handleClickOpen4 = () => {
    setOpen2(true);
  };

  const handleClickOpen2 = () => {
    setOpen3(true);
  };
  const handleClickOpen3 = () => {
    setOpen4(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
  };

  const openLink = () => {
    window.location.replace('https://amzn.eu/d/2laVQDS')
  }


  return( <div><div className="verify-product">
     <Dialog show={open}
                onHide={() => setOpen(false)}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" onBackdropClick="false"
      >
       <div className='scan-alert'>
                <strong>Did you scan this product before?</strong>
               
        <DialogActions className='ques-button'>  

              <Button variant="contained" color="success" onClick={handleClose}>Yes</Button>
              <Button variant="contained" color="error" onClick={handleClickOpen4} >No</Button>
        </DialogActions>
               </div>
      </Dialog>


      <Dialog show={open2}
         onHide={() => setOpen2(false)}
        open={open2}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" onBackdropClick="false"
      >
       <div className='scan-alert'>
                <strong>Do you want to raise query for this?</strong>
               
        <DialogActions className='ques-button'>  

              <Button variant="contained" color="success" onClick={handleClickOpen2}>Yes</Button>
              <Button variant="contained" color="error" onClick={handleClose}>No</Button>
        </DialogActions>
               </div>
      </Dialog>

      
      <Dialog show={open3}
         onHide={() => setOpen3(false)}
        open={open3}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" onBackdropClick="false"
      >
       <div className='scan-alert'>
                <strong>Submit Form</strong>
       {scanResult?.code && (
               <ul className='product-detail-lst qrcodeview'>
                  <li> QR Code : {scanResult.code}</li>
               </ul>
       )}
       <QueryForm code={scanResult?.code} formClassName="formsubmitt" onSuccess={() => { setOpen3(false); handleClickOpen3(); }} />
               </div>
      </Dialog>
 
      <Dialog show={open4}
                onHide={() => setOpen4(false)}
        open={open4}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" onBackdropClick="false"
      >
       <div className='scan-alert'>
                <strong>Thanks for submitting your query.</strong>
               
        <DialogActions className='ques-button'>  

              <Button variant="contained" color="success" onClick={handleClose}>Ok</Button>
        </DialogActions>
               </div>
      </Dialog>
 

      <div className="product-box">
       <Card className='card-box'>
          <ScanVerification initialCode={qrCode} allowSearch={false} onResult={handleScanResult} />

          <Card className='inner-card mb-10'>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <Item>
              <div className='helplinetitle'>Helpline For Any Query  <a href="tel:+91-9582 77 5555"><CallIcon/> +91-9582 77 5555</a></div>

              </Item>
            </Grid>
          </Grid>
          </Card>


       </Card>

       <PageTabs code={scanResult?.code} onBuyClick={openLink} />

      </div>
    </div>
    </div>
);
}


export default Serial;
